<div class="form-group wl-attendee-row">
  <!--Assign items column-->
  <div
    class="col-sm-4 col-sm-push-8"
    [ngClass]="{
      'col-lg-2 col-lg-push-10': displayField(event.RegAddressVisible),
      'col-lg-5 col-lg-push-5': !displayField(event.RegAddressVisible),
    }"
  >
    <p>
      <button pButton type="button" class="btn btn-danger" (click)="handleRemoveAttendeeClick()" icon="pi pi-trash">
        {{ 'events.registration.wizard.attendees.remove-attendee-button-label' | translate | titlecase }}
      </button>
    </p>
    <label>
      <input type="checkbox" [(ngModel)]="attendee.Attended" (ngModelChange)="handleAttendedClick(attendee)" />
      {{ 'events.registration.wizard.attendees.attended-label' | translate | titlecase }}
    </label>
    <h3>{{ 'events.registration.wizard.attendees.assign-items-label' | translate | titlecase }}</h3>
    <ul class="list-unstyled">
      <li *ngFor="let availEventItem of attendee.Items">
        <div *ngIf="availEventItem.AttendeesForItem > 0">
          <label>
            <input type="checkbox" [(ngModel)]="availEventItem.Selected" (ngModelChange)="attendeeItemSelectionChanged(availEventItem)" />
            {{ availEventItem.Descr }}
          </label>
        </div>
      </li>
    </ul>
  </div>
  <!--Attendee Contact Info column-->
  <div
    class="col-sm-8 col-lg-5 col-sm-pull-4"
    [ngClass]="{ 'col-lg-pull-2': displayField(event.RegAddressVisible), 'col-lg-pull-5': !displayField(event.RegAddressVisible) }"
  >
    <div *ngIf="!attendee.CreateProfile">
      <div class="form-group" *ngIf="registrationProfileId != 0">
        <div class="col-sm-offset-3 col-sm-9">
          <label>
            <input type="checkbox" [(ngModel)]="attendee.searchAllProfiles" (change)="searchAllCheckboxChange()" />
            {{ 'events.registration.wizard.attendees.search-all-profiles-label' | translate | titlecase }}
          </label>
        </div>
      </div>
      <div class="form-group" *ngIf="attendee.searchAllProfiles && registrationProfileId > 0">
        <label class="col-sm-3 control-label">
          {{ 'events.registration.wizard.attendees.profile-lookup-label' | translate | titlecase }}
        </label>
        <div class="col-sm-9">
          <wl-profile-selector
            [(ngModel)]="attendee.ProfileId"
            (onProfileChanged)="profileChanged($event, attendee)"
            [disabled]="_loadingRelatedOrgProfile.busy"
          ></wl-profile-selector>
        </div>
      </div>
      <div class="form-group" *ngIf="!attendee.searchAllProfiles && registrationProfileId != 0">
        <label class="col-sm-3 control-label">
          {{ 'events.registration.wizard.attendees.profile-lookup-label' | translate | titlecase }}
        </label>
        <div class="col-sm-9">
          <wl-related-profile-selector
            [(ngModel)]="attendee.ProfileId"
            #attendeeRelatedProfileSelectorComponent
            [relatedProfileId]="registrationProfileId"
            (onProfileChanged)="relatedProfileChanged($event, attendee)"
            [includeSelectValue]="true"
            (onProfilesLoaded)="attendee.searchAllProfiles = attendee.ProfileId > 0 && !$event"
          ></wl-related-profile-selector>
        </div>
      </div>
    </div>
    <div class="form-group" *ngIf="attendee.AttendeeId > 0 && attendee.ProfileId > 0 && attendee.ProfileId != _copiedValuesProfileId">
      <div class="col-sm-offset-3 col-sm-9">
        <button pButton type="button" class="btn btn-default" (click)="handleCopyProfileInfoClick()" icon="pi pi-arrow-circle-down">
          {{ 'events.registration.wizard.overwrite-values-from-profile' | translate | titlecase }}
        </button>
      </div>
    </div>
    <div class="form-group" *ngIf="attendee.ProfileId == 0">
      <label class="col-sm-3 control-label hidden-xs" for="attendeeChkCreateProfile">{{
        'events.registration.wizard.contact.create-profile-label' | translate | titlecase
      }}</label>
      <div class="col-sm-9">
        <div class="form-control-static">
          <label>
            <input
              type="checkbox"
              [id]="'attendeeChkCreateProfile' + _uniqueId"
              [name]="'attendeeChkCreateProfile-' + _uniqueId"
              [(ngModel)]="attendee.CreateProfile"
            />
            <span class="visible-xs-inline" for="attendeeChkCreateProfile">{{
              'events.registration.wizard.contact.create-profile-label' | translate | titlecase
            }}</span>
          </label>
        </div>
      </div>
    </div>
    <div class="form-group" *ngIf="displayField(event.RegCompanyNameVisible)">
      <label class="col-sm-3 control-label" for="attendeeContactOrgName">{{
        'events.registration.wizard.contact.org-name-label' | translate | titlecase
      }}</label>
      <div class="col-sm-9">
        <div
          [wl-busy-overlay]="_loadingRelatedOrgProfile.busy"
          [busyMessage]="'events.registration.wizard.contact.loading-related-org-message' | translate"
        >
          <input
            class="form-control"
            type="text"
            data-cy="inputRegistrationWizardAttendeeOrgName"
            [name]="'attendeeContactOrgName-' + _uniqueId"
            [(ngModel)]="attendee.OrgName"
            [disabled]="_loadingRelatedOrgProfile.busy"
          />
        </div>
        <div class="text-danger" *ngIf="!_loadingRelatedOrgProfile.busy && _loadingRelatedOrgProfile.message">
          {{ _loadingRelatedOrgProfile.message }}
        </div>
      </div>
    </div>

    <div class="form-group" *ngIf="displayField(event.RegPrefixVisible)">
      <label class="col-sm-3 control-label" for="attendeePrefix">{{
        'events.registration.wizard.contact.prefix-label' | translate | titlecase
      }}</label>
      <div class="col-sm-9">
        <input class="form-control" type="text" [name]="'attendeePrefix-' + _uniqueId" [(ngModel)]="attendee.Prefix" />
      </div>
    </div>
    <div class="form-group" *ngIf="displayField(event.RegFNameVisible)">
      <label class="col-sm-3 control-label" for="attendeeFirstName">{{
        'events.registration.wizard.contact.first-name-label' | translate | titlecase
      }}</label>
      <div class="col-sm-9">
        <input
          class="form-control"
          type="text"
          data-cy="inputRegistrationWizardAttendeeFirstName"
          [name]="'attendeeFirstName-' + _uniqueId"
          [(ngModel)]="attendee.FName"
          (ngModelChange)="onIndivNameChange(attendee)"
        />
      </div>
    </div>
    <div class="form-group" *ngIf="displayField(event.RegLNameVisible)">
      <label class="col-sm-3 control-label" for="attendeeLastName">{{
        'events.registration.wizard.contact.last-name-label' | translate | titlecase
      }}</label>
      <div class="col-sm-9">
        <input
          class="form-control"
          type="text"
          data-cy="inputRegistrationWizardAttendeeLastName"
          [name]="'attendeeLastName-' + _uniqueId"
          [(ngModel)]="attendee.LName"
          (blur)="onLastNameChange(attendee)"
          (ngModelChange)="onIndivNameChange(attendee)"
        />
      </div>
    </div>

    <div
      class="form-group"
      *ngIf="attendee.CreateProfile && profileIndDupChecker?.profileResults && profileIndDupChecker?.profileResults?.TotalCount"
    >
      max-height:;:;
      <div class="col-sm-offset-3 col-sm-9">
        <wl-profile-dup-checker
          #profileIndDupChecker
          (onProfileSelected)="onDupCheckerIndNameProfileSelected($event, attendee)"
          sourceModule="events"
        ></wl-profile-dup-checker>
      </div>
    </div>

    <div class="form-group" *ngIf="displayField(event.RegNameForBadgeVisible)">
      <label class="col-sm-3 control-label">{{
        'events.registration.wizard.attendees.name-for-badge-label' | translate | titlecase
      }}</label>
      <div class="col-sm-9">
        <input class="form-control" type="text" [name]="'attendeeNameForBadge-' + _uniqueId" [(ngModel)]="attendee.NameForBadge" />
      </div>
    </div>

    <div class="form-group" *ngIf="displayField(event.RegEmailVisible)">
      <label class="col-sm-3 control-label" for="attendeeEmail">{{
        'events.registration.wizard.contact.email-label' | translate | titlecase
      }}</label>
      <div class="col-sm-9">
        <input class="form-control" type="text" [name]="'attendeeEmail-' + _uniqueId" [(ngModel)]="attendee.Email" />
      </div>
    </div>
    <div class="form-group" *ngIf="displayField(event.RegPhoneVisible)">
      <label class="col-sm-3 control-label" for="attendeePhone">{{
        'events.registration.wizard.contact.phone-label' | translate | titlecase
      }}</label>
      <div class="col-sm-9">
        <input class="form-control" type="text" [name]="'attendeePhone-' + _uniqueId" [(ngModel)]="attendee.Phone" />
      </div>
    </div>
    <div class="form-group" *ngIf="displayField(event.RegTitleVisible)">
      <label class="col-sm-3 control-label" for="attendeeTitle">{{
        'events.registration.wizard.contact.title-label' | translate | titlecase
      }}</label>
      <div class="col-sm-9">
        <input class="form-control" type="text" [name]="'attendeeTitle-' + _uniqueId" [(ngModel)]="attendee.Title" />
      </div>
    </div>
  </div>
  <div class="col-sm-8 col-lg-5 col-lg-pull-2" *ngIf="displayField(event.RegAddressVisible)">
    <div class="form-group">
      <label class="col-sm-3 col-lg-12 hidden-lg control-label" for="attendeeAddress1">{{
        'events.registration.wizard.contact.address-label' | translate | titlecase
      }}</label>
      <label class="col-lg-12 visible-lg-block" for="attendeeAddress1">{{
        'events.registration.wizard.contact.address-label' | translate | titlecase
      }}</label>
      <div class="col-sm-9 col-lg-12">
        <div class="form-group">
          <div class="col-sm-12">
            <input class="form-control" type="text" [name]="'attendeeAddress1-' + _uniqueId" [(ngModel)]="attendee.Address1" />
          </div>
        </div>
        <div class="form-group">
          <div class="col-sm-12">
            <input class="form-control" type="text" [name]="'attendeeAddress2-' + _uniqueId" [(ngModel)]="attendee.Address2" />
          </div>
        </div>
        <div class="row">
          <div class="col-sm-3">
            <div class="form-group">
              <label class="col-sm-12" for="attendeeCity">{{
                'events.registration.wizard.contact.city-label' | translate | titlecase
              }}</label>
              <div class="col-sm-12">
                <input class="form-control" type="text" [name]="'attendeeCity-' + _uniqueId" [(ngModel)]="attendee.City" />
              </div>
            </div>
          </div>
          <div class="col-sm-5">
            <div class="form-group">
              <label class="col-sm-12" for="attendeeState">{{
                'events.registration.wizard.contact.state-label' | translate | titlecase
              }}</label>
              <div class="col-sm-12">
                <wl-state-selector [name]="'attendeeState-' + _uniqueId" [(ngModel)]="attendee.State"></wl-state-selector>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="row">
              <label class="col-sm-12" for="attendeeZip">{{
                'events.registration.wizard.contact.zip-label' | translate | titlecase
              }}</label>
              <div class="col-sm-12">
                <input class="form-control" type="text" [name]="'attendeeZip-' + _uniqueId" [(ngModel)]="attendee.Zip" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-sm-8">
    <div class="container-fluid">
      <div class="row" *ngIf="attendee.CustomFieldResponses?.length">
        <div class="col-sm-12">
          <h4>{{ 'events.registration.wizard.attendees.custom-reg-field-title' | translate | titlecase }}</h4>
        </div>
      </div>

      <wl-registration-custom-reg-fields
        #customFieldsComponent
        [customFields]="allPossibleCustomFields"
        [responses]="attendee.CustomFieldResponses"
        [visibilityFilter]="[_eventFieldVisibleRequiredEnum.AttendeeOnly, _eventFieldVisibleRequiredEnum.BothRegistrationAndAttendee]"
        [eventItemIds]="_selectedEventItemIds"
        (responseChange)="onResponseChange($event)"
      ></wl-registration-custom-reg-fields>

      <div class="form-group">
        <div class="col-sm-12">
          <div>
            <button
              type="button"
              class="btn btn-xs btn-default"
              [ngClass]="{ 'wl-event-reg-wiz-misc-fields-close-open': attendee._showMiscFields }"
              (click)="attendee._showMiscFields = !attendee._showMiscFields"
            >
              <span class="wl-event-reg-wiz-misc-fields-open-close-icon glyphicon glyphicon-chevron-down"></span>
            </button>
            <strong (click)="attendee._showMiscFields = !attendee._showMiscFields">{{
              'events.registration.wizard.attendees.miscellaneous-fields-title' | translate | titlecase
            }}</strong>
          </div>
        </div>
      </div>

      <div *ngIf="attendee._showMiscFields">
        <div class="form-group">
          <label class="col-sm-3 control-label" for="attendeePhone">{{
            'events.registration.wizard.attendees.customField-table-num-label' | translate | titlecase
          }}</label>
          <div class="col-sm-9">
            <input class="form-control" type="text" [name]="'attendeePhone-' + _uniqueId" [(ngModel)]="attendee.Custom1" />
          </div>
        </div>
        <div class="form-group">
          <label class="col-sm-3 control-label" for="attendeePhone">{{
            'events.registration.wizard.attendees.customField2-label' | translate | titlecase
          }}</label>
          <div class="col-sm-9">
            <input class="form-control" type="text" [name]="'attendeePhone-' + _uniqueId" [(ngModel)]="attendee.Custom2" />
          </div>
        </div>
        <div class="form-group">
          <label class="col-sm-3 control-label" for="attendeePhone">{{
            'events.registration.wizard.attendees.customField3-label' | translate | titlecase
          }}</label>
          <div class="col-sm-9">
            <input class="form-control" type="text" [name]="'attendeePhone-' + _uniqueId" [(ngModel)]="attendee.Custom3" />
          </div>
        </div>
        <div class="form-group">
          <label class="col-sm-3 control-label" for="attendeePhone">{{
            'events.registration.wizard.attendees.customField4-label' | translate | titlecase
          }}</label>
          <div class="col-sm-9">
            <input class="form-control" type="text" [name]="'attendeePhone-' + _uniqueId" [(ngModel)]="attendee.Custom4" />
          </div>
        </div>
        <div class="form-group">
          <label class="col-sm-3 control-label" for="attendeePhone">{{
            'events.registration.wizard.attendees.customField5-label' | translate | titlecase
          }}</label>
          <div class="col-sm-9">
            <input class="form-control" type="text" [name]="'attendeePhone-' + _uniqueId" [(ngModel)]="attendee.Custom5" />
          </div>
        </div>
        <div class="form-group">
          <label class="col-sm-3 control-label">{{ 'events.registration.wizard.attendees.notes-label' | translate | titlecase }}</label>
          <div class="col-sm-9">
            <textarea class="form-control" type="text" [name]="'attendeeNotes-' + _uniqueId" [(ngModel)]="attendee.Notes"></textarea>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
